/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as MagicLoginRouteImport } from './routes/magic-login'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as MeetTokenRouteImport } from './routes/meet.$token'
import { Route as CsatTokenRouteImport } from './routes/csat.$token'
import { Route as AuthTiktokCallbackRouteImport } from './routes/_auth/tiktok-callback'
import { Route as AuthTeamsRouteImport } from './routes/_auth/teams'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthReportsRouteImport } from './routes/_auth/reports'
import { Route as AuthNovedadesRouteImport } from './routes/_auth/novedades'
import { Route as AuthMeetingsRouteImport } from './routes/_auth/meetings'
import { Route as AuthKnowledgeBaseRouteImport } from './routes/_auth/knowledge-base'
import { Route as AuthKanbanRouteImport } from './routes/_auth/kanban'
import { Route as AuthIntegrationsRouteImport } from './routes/_auth/integrations'
import { Route as AuthInboxAgentRouteImport } from './routes/_auth/inbox-agent'
import { Route as AuthFilesRouteImport } from './routes/_auth/files'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthContactsRouteImport } from './routes/_auth/contacts'
import { Route as AuthCommentsRouteImport } from './routes/_auth/comments'
import { Route as AuthChatRouteImport } from './routes/_auth/chat'
import { Route as AuthCallsRouteImport } from './routes/_auth/calls'
import { Route as AuthBotBuilderRouteImport } from './routes/_auth/bot-builder'
import { Route as AuthAgentPlatformRouteImport } from './routes/_auth/agent-platform'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const MagicLoginRoute = MagicLoginRouteImport.update({
  id: '/magic-login',
  path: '/magic-login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetTokenRoute = MeetTokenRouteImport.update({
  id: '/meet/$token',
  path: '/meet/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CsatTokenRoute = CsatTokenRouteImport.update({
  id: '/csat/$token',
  path: '/csat/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTiktokCallbackRoute = AuthTiktokCallbackRouteImport.update({
  id: '/tiktok-callback',
  path: '/tiktok-callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTeamsRoute = AuthTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsRoute = AuthReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNovedadesRoute = AuthNovedadesRouteImport.update({
  id: '/novedades',
  path: '/novedades',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeetingsRoute = AuthMeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKnowledgeBaseRoute = AuthKnowledgeBaseRouteImport.update({
  id: '/knowledge-base',
  path: '/knowledge-base',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKanbanRoute = AuthKanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIntegrationsRoute = AuthIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxAgentRoute = AuthInboxAgentRouteImport.update({
  id: '/inbox-agent',
  path: '/inbox-agent',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFilesRoute = AuthFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContactsRoute = AuthContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCommentsRoute = AuthCommentsRouteImport.update({
  id: '/comments',
  path: '/comments',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChatRoute = AuthChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallsRoute = AuthCallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBotBuilderRoute = AuthBotBuilderRouteImport.update({
  id: '/bot-builder',
  path: '/bot-builder',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentPlatformRoute = AuthAgentPlatformRouteImport.update({
  id: '/agent-platform',
  path: '/agent-platform',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/magic-login': typeof MagicLoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/agent-platform': typeof AuthAgentPlatformRoute
  '/bot-builder': typeof AuthBotBuilderRoute
  '/calls': typeof AuthCallsRoute
  '/chat': typeof AuthChatRoute
  '/comments': typeof AuthCommentsRoute
  '/contacts': typeof AuthContactsRoute
  '/dashboard': typeof AuthDashboardRoute
  '/files': typeof AuthFilesRoute
  '/inbox-agent': typeof AuthInboxAgentRoute
  '/integrations': typeof AuthIntegrationsRoute
  '/kanban': typeof AuthKanbanRoute
  '/knowledge-base': typeof AuthKnowledgeBaseRoute
  '/meetings': typeof AuthMeetingsRoute
  '/novedades': typeof AuthNovedadesRoute
  '/reports': typeof AuthReportsRoute
  '/settings': typeof AuthSettingsRoute
  '/teams': typeof AuthTeamsRoute
  '/tiktok-callback': typeof AuthTiktokCallbackRoute
  '/csat/$token': typeof CsatTokenRoute
  '/meet/$token': typeof MeetTokenRoute
  '/oauth/consent': typeof OauthConsentRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/magic-login': typeof MagicLoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/agent-platform': typeof AuthAgentPlatformRoute
  '/bot-builder': typeof AuthBotBuilderRoute
  '/calls': typeof AuthCallsRoute
  '/chat': typeof AuthChatRoute
  '/comments': typeof AuthCommentsRoute
  '/contacts': typeof AuthContactsRoute
  '/dashboard': typeof AuthDashboardRoute
  '/files': typeof AuthFilesRoute
  '/inbox-agent': typeof AuthInboxAgentRoute
  '/integrations': typeof AuthIntegrationsRoute
  '/kanban': typeof AuthKanbanRoute
  '/knowledge-base': typeof AuthKnowledgeBaseRoute
  '/meetings': typeof AuthMeetingsRoute
  '/novedades': typeof AuthNovedadesRoute
  '/reports': typeof AuthReportsRoute
  '/settings': typeof AuthSettingsRoute
  '/teams': typeof AuthTeamsRoute
  '/tiktok-callback': typeof AuthTiktokCallbackRoute
  '/csat/$token': typeof CsatTokenRoute
  '/meet/$token': typeof MeetTokenRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/': typeof AuthIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/magic-login': typeof MagicLoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/agent-platform': typeof AuthAgentPlatformRoute
  '/_auth/bot-builder': typeof AuthBotBuilderRoute
  '/_auth/calls': typeof AuthCallsRoute
  '/_auth/chat': typeof AuthChatRoute
  '/_auth/comments': typeof AuthCommentsRoute
  '/_auth/contacts': typeof AuthContactsRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/files': typeof AuthFilesRoute
  '/_auth/inbox-agent': typeof AuthInboxAgentRoute
  '/_auth/integrations': typeof AuthIntegrationsRoute
  '/_auth/kanban': typeof AuthKanbanRoute
  '/_auth/knowledge-base': typeof AuthKnowledgeBaseRoute
  '/_auth/meetings': typeof AuthMeetingsRoute
  '/_auth/novedades': typeof AuthNovedadesRoute
  '/_auth/reports': typeof AuthReportsRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/teams': typeof AuthTeamsRoute
  '/_auth/tiktok-callback': typeof AuthTiktokCallbackRoute
  '/csat/$token': typeof CsatTokenRoute
  '/meet/$token': typeof MeetTokenRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/_auth/': typeof AuthIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/magic-login'
    | '/onboarding'
    | '/reset-password'
    | '/agent-platform'
    | '/bot-builder'
    | '/calls'
    | '/chat'
    | '/comments'
    | '/contacts'
    | '/dashboard'
    | '/files'
    | '/inbox-agent'
    | '/integrations'
    | '/kanban'
    | '/knowledge-base'
    | '/meetings'
    | '/novedades'
    | '/reports'
    | '/settings'
    | '/teams'
    | '/tiktok-callback'
    | '/csat/$token'
    | '/meet/$token'
    | '/oauth/consent'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/magic-login'
    | '/onboarding'
    | '/reset-password'
    | '/agent-platform'
    | '/bot-builder'
    | '/calls'
    | '/chat'
    | '/comments'
    | '/contacts'
    | '/dashboard'
    | '/files'
    | '/inbox-agent'
    | '/integrations'
    | '/kanban'
    | '/knowledge-base'
    | '/meetings'
    | '/novedades'
    | '/reports'
    | '/settings'
    | '/teams'
    | '/tiktok-callback'
    | '/csat/$token'
    | '/meet/$token'
    | '/oauth/consent'
    | '/'
  id:
    | '__root__'
    | '/_auth'
    | '/forgot-password'
    | '/login'
    | '/magic-login'
    | '/onboarding'
    | '/reset-password'
    | '/_auth/agent-platform'
    | '/_auth/bot-builder'
    | '/_auth/calls'
    | '/_auth/chat'
    | '/_auth/comments'
    | '/_auth/contacts'
    | '/_auth/dashboard'
    | '/_auth/files'
    | '/_auth/inbox-agent'
    | '/_auth/integrations'
    | '/_auth/kanban'
    | '/_auth/knowledge-base'
    | '/_auth/meetings'
    | '/_auth/novedades'
    | '/_auth/reports'
    | '/_auth/settings'
    | '/_auth/teams'
    | '/_auth/tiktok-callback'
    | '/csat/$token'
    | '/meet/$token'
    | '/oauth/consent'
    | '/_auth/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MagicLoginRoute: typeof MagicLoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  CsatTokenRoute: typeof CsatTokenRoute
  MeetTokenRoute: typeof MeetTokenRoute
  OauthConsentRoute: typeof OauthConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magic-login': {
      id: '/magic-login'
      path: '/magic-login'
      fullPath: '/magic-login'
      preLoaderRoute: typeof MagicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meet/$token': {
      id: '/meet/$token'
      path: '/meet/$token'
      fullPath: '/meet/$token'
      preLoaderRoute: typeof MeetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/csat/$token': {
      id: '/csat/$token'
      path: '/csat/$token'
      fullPath: '/csat/$token'
      preLoaderRoute: typeof CsatTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/tiktok-callback': {
      id: '/_auth/tiktok-callback'
      path: '/tiktok-callback'
      fullPath: '/tiktok-callback'
      preLoaderRoute: typeof AuthTiktokCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/teams': {
      id: '/_auth/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof AuthTeamsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports': {
      id: '/_auth/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthReportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/novedades': {
      id: '/_auth/novedades'
      path: '/novedades'
      fullPath: '/novedades'
      preLoaderRoute: typeof AuthNovedadesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/meetings': {
      id: '/_auth/meetings'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof AuthMeetingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/knowledge-base': {
      id: '/_auth/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/knowledge-base'
      preLoaderRoute: typeof AuthKnowledgeBaseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kanban': {
      id: '/_auth/kanban'
      path: '/kanban'
      fullPath: '/kanban'
      preLoaderRoute: typeof AuthKanbanRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/integrations': {
      id: '/_auth/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthIntegrationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox-agent': {
      id: '/_auth/inbox-agent'
      path: '/inbox-agent'
      fullPath: '/inbox-agent'
      preLoaderRoute: typeof AuthInboxAgentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/files': {
      id: '/_auth/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AuthFilesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contacts': {
      id: '/_auth/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthContactsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/comments': {
      id: '/_auth/comments'
      path: '/comments'
      fullPath: '/comments'
      preLoaderRoute: typeof AuthCommentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/chat': {
      id: '/_auth/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthChatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/calls': {
      id: '/_auth/calls'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof AuthCallsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bot-builder': {
      id: '/_auth/bot-builder'
      path: '/bot-builder'
      fullPath: '/bot-builder'
      preLoaderRoute: typeof AuthBotBuilderRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agent-platform': {
      id: '/_auth/agent-platform'
      path: '/agent-platform'
      fullPath: '/agent-platform'
      preLoaderRoute: typeof AuthAgentPlatformRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAgentPlatformRoute: typeof AuthAgentPlatformRoute
  AuthBotBuilderRoute: typeof AuthBotBuilderRoute
  AuthCallsRoute: typeof AuthCallsRoute
  AuthChatRoute: typeof AuthChatRoute
  AuthCommentsRoute: typeof AuthCommentsRoute
  AuthContactsRoute: typeof AuthContactsRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthFilesRoute: typeof AuthFilesRoute
  AuthInboxAgentRoute: typeof AuthInboxAgentRoute
  AuthIntegrationsRoute: typeof AuthIntegrationsRoute
  AuthKanbanRoute: typeof AuthKanbanRoute
  AuthKnowledgeBaseRoute: typeof AuthKnowledgeBaseRoute
  AuthMeetingsRoute: typeof AuthMeetingsRoute
  AuthNovedadesRoute: typeof AuthNovedadesRoute
  AuthReportsRoute: typeof AuthReportsRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthTeamsRoute: typeof AuthTeamsRoute
  AuthTiktokCallbackRoute: typeof AuthTiktokCallbackRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAgentPlatformRoute: AuthAgentPlatformRoute,
  AuthBotBuilderRoute: AuthBotBuilderRoute,
  AuthCallsRoute: AuthCallsRoute,
  AuthChatRoute: AuthChatRoute,
  AuthCommentsRoute: AuthCommentsRoute,
  AuthContactsRoute: AuthContactsRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthFilesRoute: AuthFilesRoute,
  AuthInboxAgentRoute: AuthInboxAgentRoute,
  AuthIntegrationsRoute: AuthIntegrationsRoute,
  AuthKanbanRoute: AuthKanbanRoute,
  AuthKnowledgeBaseRoute: AuthKnowledgeBaseRoute,
  AuthMeetingsRoute: AuthMeetingsRoute,
  AuthNovedadesRoute: AuthNovedadesRoute,
  AuthReportsRoute: AuthReportsRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthTeamsRoute: AuthTeamsRoute,
  AuthTiktokCallbackRoute: AuthTiktokCallbackRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MagicLoginRoute: MagicLoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  CsatTokenRoute: CsatTokenRoute,
  MeetTokenRoute: MeetTokenRoute,
  OauthConsentRoute: OauthConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
